import React from "react";
import {Link} from "react-router";

import Right from "./Right";
import Panel from "./Panel";
//import CoolLoader from "./CoolLoader";
import CoolLoader2 from "./CoolLoader2";
import {api, classLoader, parsePHPtime} from "./baseFunctions";

import "./css/dashboard.css";

export default class OldRiskAssessment extends React.Component {
	constructor(props){
		super(props);
    this.getData = this.getData.bind(this);
    this.getRA = this.getRA.bind(this);
    this.drawChart = this.drawChart.bind(this);
    this.preloadReport = this.preloadReport.bind(this);
		this.state = {
			data: [],
      showReport: props.params.id ? Number(props.params.id) : false,
      reportData: {
        name: "",
        customer: "",
        createdBy: "",
        start: "",
        end: "",
        questions: [],
        preQuestions: 0,
      }
		};
	}
	componentDidMount(){
		this.getData();
    if(this.props.params.id)
    {
      this.getRA(this.props.params.id);
    }
	}

  preloadReport(id){
    const curr = this.state.data[id];
    var data = {...this.state.reportData};
    data.name = curr.name;
    data.start = curr.time;
    data.end = curr.date;
    data.createdBy = curr.createdBy;
    data.customer = curr.customer;
    data.questions = [];
    this.setState({reportData: data, showReport: Number(curr.id)});
    this.getRA(curr.id);
  }
  getRA(id)
  {
    api("POST", {"type": "getOldRA", id}, (d) => {
      if(!d.error)
      {
        this.setState({reportData: d.data});
      }else{
        alert(d.msg);
      }
    }, this.props.auth);
  }
  drawChart(d){
    var ctx = this.canvas;
    var dataSet = {};
    d.map((d, key) => {
      if(Object.keys(dataSet).length < 30 && d.points > 0)
      {
        var date = new Date(d.time * 1000);
        var index = date.getDate() + "/" + date.getMonth(); 
        dataSet[index] = dataSet[index] ? dataSet[index] + d.points : d.points;
      }
    });
    var largestY = 0;
    var chart = new window.Chart(ctx, {
        type: 'line',
        data: {
            labels: Object.keys(dataSet).reverse(),
            datasets: [{
                label: "Point",
                backgroundColor: 'rgba(42, 63, 84, 0.74)',
                borderColor: 'rgba(42, 63, 84, 0.74)',
                data: Object.keys(dataSet).map((key) => {
                  var curr = dataSet[key];
                  if(curr > largestY)
                  {
                    largestY = curr;
                  }
                  return curr;
                }).reverse(),
            }]
        },

        // Configuration options go here
        options: {
              responsive: true,
              tooltips: {
                mode: "index",
                intersect: false,
              },
              hover: {
                mode: "index",
                intersect: false
              },
          scales: {
        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepValue: 5,
                                max: largestY
                            }
                        }]
    }
        }
    });
    ctx.addEventListener("click", (ev) => {
      var activePoints = chart.getElementsAtEvent(ev);
      if(activePoints.length > 0)
      {
        var clickedElementindex = activePoints[0]["_index"];
        var label = chart.data.labels[clickedElementindex];   
        var value = chart.data.datasets[0].data[clickedElementindex];
        //this.dataTable.search("Kenneth").draw();
        label = label.split("/");
        label[0] = label[0] < 10 ? "0" + label[0] : label[0];
        label[1] = label[1] < 10 ? "0" + label[1] : label[1];
        label = label[1] + "-" + label[0];
        var table = window.$('#ras').DataTable();
        table.search(label).draw();
     }
    });
  }
	getData(){
		api("POST", {"type": "getOldRAs"}, (d) => {
			if(!d.error)
			{
        //return 1;
				this.setState({
					data: d.data
				});
        this.drawChart(d.data);
				window.$("#ras").dataTable({
            "iDisplayLength": 50,
            "order": [[ 0, "desc" ]],
            "language": {
                "lengthMenu": "Vis _MENU_ pr side",
                "zeroRecords": "Intet fundet",
                "info": "Side _PAGE_ / _PAGES_",
                "infoEmpty": "Intet indhold",
                "search":         "Søg: ",
                 "paginate": {
                    "first":      "Første",
                    "last":       "Sidste",
                    "next":       "Næste",
                    "previous":   "Forrige"
                },
                "infoFiltered": "(filterer fra _MAX_ colonner)"
            }
        });
			}
		}, this.props.auth);
	}
	render(){
    const repData = this.state.reportData;
    var tempI = 0;
		return (
			<Right title="Besvarelser">
        {
          typeof this.state.showReport === "number" ? 
          <Panel title="Report">
            <CoolLoader2 show={repData.name.length === 0} type="table"/>
            <table className="table table-striped jambo_table bulk_action" style={repData.name === 0 ? {"display": "none"} : {}}>
              <thead>
                  <tr className="headings">
                      <th className="column-title">Titel</th>
                      <th className="column-title">Kunde</th>
                      <th className="column-title">Lavet af</th>
                      <th className="column-title">Start tidspunkt</th>
                      <th className="column-title">Afslutnings tidspunkt</th>
                  </tr>
              </thead>
              <tbody>
                <tr>
                    <td>{repData.name}</td>
                    <td>{repData.customer}</td>
                    <td>{repData.createdBy}</td>
                    <td>{repData.start}</td>
                    <td>{repData.end}</td>
                </tr>                                            
              </tbody>
            </table>

            <CoolLoader2 show={repData.questions.length === 0} type="table"/>
            <table className="table table-striped jambo_table bulk_action" style={repData.questions.length === 0 ? {"display": "none"} : {}}>
              {
                repData.questions.map((d, key) => {
                  if(d == null || d.item == null)
                  {
                    return "";
                  }
                  if(d.item.title === "1")
                  {
                    return (<thead>
                              <tr className="headings">
                                  <th className="column-title">{d.item['value_DK']}</th>
                                  <th className="column-title">Svar</th>
                                  <th className="column-title">Sandsynlighed</th>
                                  <th className="column-title">Konsekvens</th>
                                  <th className="column-title">Korrekt?</th>
                                  <th className="column-title">Svar ændret</th>
                                  <th className="column-title">Kommentar</th>
                              
                          </tr>
                      </thead>);
                  }else{
                    tempI++;
                    return (<tbody>
                      <tr className={tempI%2 ? "odd pointer" : "even pointer"}>
                        <td className=" ">{d.item['value_DK']}</td>
                        <td className=" ">{d.value == "1" ? "Ja" : "Nej"}</td>
                        <td className=" "></td>
                        <td className=" "></td>
                        <td className=" "><i className="fa fa-check"></i></td>
                        <td className=" ">1</td>
                        <td className=" "></td>
                        
                        </tr>
                    </tbody>);
                  }
                })
              }
            </table>
          </Panel> : ""
        }
        <Panel title="Statistik">
            <CoolLoader2 show={this.state.data.length === 0} type="lineGraph" width="600" height="120"/>
            <canvas ref={(me) => this.canvas = me} width="600" height="120" style={this.state.data.length === 0 ? {width: "100%", "display": "none"} : {width: "100%"}}></canvas>
        </Panel>
				<Panel title="Oversigt">
					<div className="table-responsive">
            <CoolLoader2 show={this.state.data.length === 0} type="table"/>
            
            <table className="table table-striped jambo_table bulk_action" id="ras" style={this.state.data.length === 0 ? {"display": "none"} : {}}>
            		<thead>
                  <tr className="headings">
                      <th className="column-title"># </th>
                      <th className="column-title">Titel </th>
                      <th className="column-title">Startet </th>
                      <th className="column-title">Afsluttet </th>
                      <th className="column-title">Af </th>
                      <th className="column-title">Risiko </th>
                      <th className="column-title">Antal noter </th>
                      <th className="column-title">Addresse </th>
                      <th className="column-title"> </th>
                  </tr>
              	</thead>
                <tbody>
                {
                	this.state.data.map((d, key) => {
                		return (<tr key={key} className={key%2 ? "even pointer" : "odd pointer"}>
                        <td className=" ">{d.id}</td>
                        <td className=" ">{d.name}</td>
                        <td className=" ">{parsePHPtime(d.time)}</td>
                        <td className=" " dangerouslySetInnerHTML={{__html:d.date}}></td>
                        <td className=" ">{d.createdBy}</td>
                        <td className=" ">{d.points}</td>
                        <td className=" ">{d.commentsAmount}</td>
                        <td className=" ">{d.address}</td>
                        <td className=" last">
                        	<Link to={"/oldRa/" + d.id} onClick={() => this.preloadReport(key)}>Vis rapport</Link> / <a target="_blank" href={"https://safeallday.dk/administration/showReport.php?show=" + d.id + "&lang=DK&hash=" + d.hash}>Offentlig rapport</a>
                        </td>
                    </tr>);
                	})
                }                 
                </tbody>
            </table>
        </div>
				</Panel>
			</Right>);
	}
}


// WEBPACK FOOTER //
// ./src/components/OldRiskAssessment.js